module.exports = __webpack_public_path__ + "static/logo-header-fb8fcc391f0199986747e7571a500b3d.svg";